import {ProductGateway} from "../classes";
import product from '@ppcp/product';
import cart from '@ppcp/cart';
import Actions from '@ppcp/actions';

new ProductGateway(product, cart, {id: 'ppcp', actions: new Actions(), context: 'product'});